import { Injectable, inject } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { ConfirmDialogComponent } from '@core/dialog/confirm-dialog.component'
import { EqAlDialogComponent } from '@core/dialog/eq-al-dialog.component'
import { JsonDialogComponent } from '@core/dialog/json-dialog.component'
import { lastValueFrom } from 'rxjs'

export interface DialogServiceConfirmParams {
  title: string
  message: string
  themeType?: string
  cancelText?: string
  confirmText?: string
}

@Injectable({ providedIn: 'root' })
export class DialogService {
  MatDialog = inject(MatDialog)

  async confirm (_: DialogServiceConfirmParams): Promise<any> {
    const res = await lastValueFrom(this.MatDialog.open(ConfirmDialogComponent, { ...(new MatDialogConfig()), data: _ }).afterClosed())
    return res
  }

  async eqAl (_: any): Promise<any> {
    const res = await lastValueFrom(this.MatDialog.open(EqAlDialogComponent, { ...(new MatDialogConfig()), data: _ }).afterClosed())
    return res
  }

  async json (_: any): Promise<any> {
    const res = await lastValueFrom(this.MatDialog.open(JsonDialogComponent, { ...(new MatDialogConfig()), data: _ }).afterClosed())
    return res
  }
}
